import React from 'react';
import { useMutation } from '@apollo/client';
import { FormattedMessage } from 'react-intl';
import { Button, Typography, useMediaQuery, useTheme } from '@mui/material';

import { CREATE_DENTOLO_LEAD_WITH_CUSTOMER_DATA } from '../../../graphql/mutations/leads';
import { imgLinks, DENTOLO_ADDITIONAL_INSURANCE_URL, GETOLO_UTM_PARAMS } from '../../../shared';

import {
  StyledAdditionalDentoloInsuranceCard,
  StyledAdditionalDentoloInsuranceCardTextContent,
  StyledAdditionalDentoloInsuranceCardImage,
  StyledAdditionalDentoloInsuranceCardTitle,
  StyledAdditionalDentoloInsuranceCardContent,
} from './AdditionalDentoloInsuranceCard.styled';

const utmSource = `utm_source=${GETOLO_UTM_PARAMS.source}`;
const utmCampaign = `utm_campaign=${GETOLO_UTM_PARAMS.campaignAdditionalDentoloInsurance}`;

const goToFunnel = ({ uuid }) => {
  if (!uuid) return;

  const urlToInsureAnotherPetFunnel = `${DENTOLO_ADDITIONAL_INSURANCE_URL}&uuid=${uuid}&${utmSource}&${utmCampaign}`;

  window.open(urlToInsureAnotherPetFunnel, '_blank');
};

const handleRequestComplete = (data) => {
  const newUuid = data?.insureAnotherPerson?.uuid;

  if (newUuid) {
    goToFunnel({ uuid: newUuid });
  }
};

function AdditionalDentoloInsuranceCard() {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('desktop'));

  const [
    createDentoloLeadWithCustomerData,
    { data: response, called: newUuidCalled, loading: newUuidLoading },
  ] = useMutation(CREATE_DENTOLO_LEAD_WITH_CUSTOMER_DATA);

  const additionalDentoloInsuranceBtnClick = () => {
    const newLeadUuid = response?.insureAnotherPerson?.uuid;

    if (newLeadUuid) {
      goToFunnel({ uuid: newLeadUuid });
      return;
    }

    createDentoloLeadWithCustomerData({
      onCompleted: handleRequestComplete,
    });
  };

  const disableButton = newUuidCalled && newUuidLoading;

  return (
    <StyledAdditionalDentoloInsuranceCard>
      <StyledAdditionalDentoloInsuranceCardContent>
        <StyledAdditionalDentoloInsuranceCardTextContent>
          <StyledAdditionalDentoloInsuranceCardTitle>
            <Typography variant={isDesktop ? 'h2' : 'h3'}>
              <FormattedMessage id="promotion.carousel.dentolo.additional_insurance.title" />
            </Typography>
          </StyledAdditionalDentoloInsuranceCardTitle>

          <Typography variant="p">
            <FormattedMessage id="promotion.carousel.dentolo.additional_insurance.text" />
          </Typography>

          {isDesktop && (
            <Button
              type="button"
              onClick={additionalDentoloInsuranceBtnClick}
              disabled={disableButton}
            >
              <Typography variant="buttons">
                <FormattedMessage id="promotion.carousel.dentolo.additional_insurance.button.label" />
              </Typography>
            </Button>
          )}
        </StyledAdditionalDentoloInsuranceCardTextContent>

        <StyledAdditionalDentoloInsuranceCardImage
          src={imgLinks['carousel.another.dentolo.contract.image']}
          alt="Additional Dentolo Insurance"
        />
      </StyledAdditionalDentoloInsuranceCardContent>

      {!isDesktop && (
        <Button type="button" onClick={additionalDentoloInsuranceBtnClick} disabled={disableButton}>
          <Typography variant="buttons">
            <FormattedMessage id="promotion.carousel.dentolo.additional_insurance.button.label" />
          </Typography>
        </Button>
      )}
    </StyledAdditionalDentoloInsuranceCard>
  );
}

export default AdditionalDentoloInsuranceCard;
